module.exports = __webpack_public_path__ + "img/sacagawea-min.8f5c9b26.png";